import React, { useState } from 'react';
import { ShieldCheck } from 'lucide-react';

export default function Profile({ user }) {
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');

    const handleChange = async (e) => {
        e.preventDefault();
        if (!password) return;
        try {
            const res = await fetch(`/api/users/${user.id}`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password }),
            });
            const data = await res.json();
            if (res.ok) {
                setMessage('Password updated successfully');
                setPassword('');
            } else {
                setMessage(data.error || 'Failed to update password');
            }
        } catch (err) {
            console.error(err);
            setMessage('Error updating password');
        }
    };

    return (
        <section className="card">
            <h2><ShieldCheck size={20} /> Profile Settings</h2>
            {message && <p className="notice">{message}</p>}
            <form onSubmit={handleChange} className="form">
                <label>New Password</label>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter new password"
                    required
                />
                <button type="submit">Change Password</button>
            </form>
        </section>
    );
}
